export const PERSONAL_CHAT_INACTIVE_MS = 48 * 60 * 60 * 1000;
export const PERSONAL_CHAT_AUTO_TIDY_MS = 96 * 60 * 60 * 1000;

type ChatEntry = {
  entryType: string;
  createdAt: number;
};

export function lastPersonalChatMessageAt(
  entries: readonly ChatEntry[] | undefined,
  createdAt: number
) {
  let latest = createdAt;
  for (const entry of entries ?? []) {
    if (entry.entryType === "UserMessage") {
      latest = Math.max(latest, entry.createdAt);
    }
  }
  return latest;
}

export function isPersonalChatInactive(
  lastMessageAt: number,
  now = Date.now(),
  thresholdMs = PERSONAL_CHAT_INACTIVE_MS
) {
  return lastMessageAt < now - thresholdMs;
}

export function isPersonalChatInactiveByEntries(
  entries: readonly ChatEntry[] | undefined,
  createdAt: number,
  now = Date.now()
) {
  // A chat with no user messages is empty clutter (e.g. a stray "+"), so it's
  // always tidy-able regardless of how recently it was created.
  const hasUserMessage = (entries ?? []).some(
    (e) => e.entryType === "UserMessage"
  );
  if (!hasUserMessage) return true;
  return isPersonalChatInactive(
    lastPersonalChatMessageAt(entries, createdAt),
    now
  );
}

// Purely time-based (unlike manual tidy, empties aren't force-closed until
// they've aged out) so the automatic sweep only touches abandoned chats.
export function isPersonalChatAutoTidyByEntries(
  entries: readonly ChatEntry[] | undefined,
  createdAt: number,
  now = Date.now()
) {
  return isPersonalChatInactive(
    lastPersonalChatMessageAt(entries, createdAt),
    now,
    PERSONAL_CHAT_AUTO_TIDY_MS
  );
}
